import axios from "axios";

/** Risolve path relativi degli asset report rispetto al backend API. */
export function resolveReportAssetUrl(url) {
  if (!url || typeof url !== "string") return null;

  const trimmed = url.trim();
  if (/^https?:\/\//i.test(trimmed)) return trimmed;

  const baseUrl = (process.env.REACT_APP_BASE_URL ?? "").replace(/\/$/, "");
  const apiOrigin = baseUrl.replace(/\/api\/v\d+$/i, "");

  if (trimmed.startsWith("/")) {
    return `${apiOrigin}${trimmed}`;
  }

  return `${baseUrl}/${trimmed.replace(/^\//, "")}`;
}

/** Scarica un file report (ECG raw, PDF, …) con auth se disponibile. */
export function fetchReportAsset(url, authHeader) {
  const resolved = resolveReportAssetUrl(url);
  if (!resolved) {
    return Promise.reject(new Error("URL asset report non valido"));
  }

  const headers = {};
  if (authHeader) {
    const authorization = authHeader();
    if (authorization) {
      headers.Authorization = authorization;
    }
  }

  return axios.get(resolved, { headers });
}

/** ECGRaw può essere un array inline (nuova API) o un URL da scaricare (legacy). */
export async function resolveECGRaw(report, authHeader) {
  const ecgRaw = report?.data?.ECGRaw;

  if (ecgRaw == null) {
    throw new Error("Dati ECG non disponibili");
  }

  if (Array.isArray(ecgRaw)) {
    return ecgRaw;
  }

  if (typeof ecgRaw === "string") {
    const res = await fetchReportAsset(ecgRaw, authHeader);
    return res.data;
  }

  return ecgRaw;
}
